import { Elastic, TweenLite } from "gsap";
import { AwardOptionPosition, ExtendedSpinAndHoldEndAction, PlayWindow, ScatterRandomAwardResult, SimpleBonusPhase, SimpleSlotGameState, SpinAndHoldCommonConfiguration, SpinAndHoldSpinAction, SpinAndHoldStartAction, UnlockRowsConfig, UnlockRowsResult } from "../../../api";
import { Track } from "../../../AudioManager";
import { assertNotNullish } from "../../../debug";
import { CreateElement, Filter, FilterFeatures, LogGroup, Point, Rect, Scale, SetStyles, Size, TranslateScreen1To1 } from "../../../MyHelpers";
import { ImageResource } from "../../../ResourceManager/ImageResource";
import { PixiSpriteResource } from "../../../ResourceManager/PixiSpriteResource";
import { Resourceful2 } from "../../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage } from "../../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../../ResourceManager/SpriteResource";
import { VideoResource2 } from "../../../ResourceManager/VideoResource";
import { service } from "../../../services";
import { JackpotDisplayType, Presentation, Settings } from "../../../Settings";
import { ParseMonitors } from "../../../system/ParseMonitors";
import { ZIndex } from "../../../ZIndex";
import { MyCanvas, MyCanvasContext } from "../../MyCanvas";
import { ScatterRandomAwardResults } from "../../ScatterRandomAward/ScatterRandomAward";
import { IBonusStartConfig } from "../../SlotGame";
import { S2_SpinnableReelsBigCanvas2 } from "../../SpinAnimation2/SpinnableReelsBigCanvas2";
import { CanvasSprite } from "../../Sprite/CanvasSprite";
import { ITransitionParams } from "../../Transition/ITransitionFactory";
import { TransitionPIXITypeStyle } from "../../Transition/VideoSpriteTransitionParticlesPIXIFadeInFadeOut";
import { ConstructReelsParams } from "../SlotBonus";
import { SpinAndHoldBonus, SpinAndHoldContainer } from "../SpinAndHold/SpinAndHold";
import { SpinAndHoldParams } from "../SpinAndHold/SpinAndHoldParams";
import { SpinAndHoldRunResult } from "../SpinAndHold/SpinAndHoldRunResult";
//import { IUnlockFeatureParams, UnlockFeature } from "./UnlockFeature";

export enum ExtededSpinAndHoldBonusGameState {
	SpinsRemaining,
	LastSpin,
	WinCount,
}

export interface ExtendedSpinAndHoldRunResult extends SpinAndHoldRunResult {
	FeatureResults: {
		ScatterRandomAward: ScatterRandomAwardResults,
		UnlockRows: UnlockRowsResult
	};
}

export class ExtendedSpinAndHold extends SpinAndHoldBonus implements Resourceful2 {
	public override OnResize(): void {
		throw new Error("Method not implemented.");
	}

	// public override CreateTransitionPixi(): void {
	// 	//throw new Error("Method not implemented.");
	// 	this.transitionView.CreateTransitionPixi();
	// }
	// public override DestroyTransition(): void {
	// 	//throw new Error("Method not implemented.");
	// 	this.transitionView.DestroyTransitionPixi();
	// }

	//public unlockFeature: UnlockFeature;
	// protected windowRectangle: PixelRect;
	protected winCountCanvas: MyCanvas;
	//protected animWinCount: TweenLite;
	//protected jackpotHideAnim: TimelineMax;
	protected bonusWinSprite: CanvasSprite;
	//Remaining stats 
	protected remainingSpinsCanvas: MyCanvas = null;
	protected ctxWremainingSpinsCanvas: MyCanvasContext = null;
	protected infoHeightWinCount: number = Scale.fh(200);
	protected infoHeightRemainingSpinsCanvas: number = Scale.fh(100);
	//protected lastSpinResultSave: SpinAndHoldRunResult = null;
	protected override BonusName(): string {
		return "ExtendedSpinAndHold";
	}

	public constructor(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration) {
		super(gameName, params, config);
		//Create WindowRec
		// let xratio = 1;
		// let yratio = 1;
		// this.windowRectangle = new PixelRect(Scale.X(74.0) * xratio, Scale.Y(-968) * yratio, Scale.W(1774.0) * xratio, Scale.H(1885.0) * yratio);
		this.view.style.height = Scale.Hpx((1080 * this.ScreenNumberConfiguration));
		this.view.style.width = Scale.Wpx(1920);
		this.view.style.top = Scale.Ypx(-2160);
		this.view.style.position = "absolute";
	}

	public override async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
		await super.PrepareResources(loadingStage, resourceManager);

		if (loadingStage != LoadingStage.Games) return;
		
		resourceManager.Add(new SpriteResource(this.params.commonBonusResourcesBasePath + "resources/BonusTitle", this.resid.Add("bonusTitleExtendedSpinAndHold"), true, this.logGroup.Add("bonusTitleExtendedSpinAndHold"), true));
		resourceManager.Add(new SpriteResource(this.params.commonBonusResourcesBasePath + `resources/FramesWinSpine/${Settings.JackpotDisplayType}/frameSpriteWin`, this.resid.Add("frameSpriteExtendedSpinAndHold"), true, this.logGroup.Add("frameSpriteExtendedSpinAndHold"), true));
		
		//resourceManager.Add(new ImageResource(this.params.gameBonusResourcesBasePath + "background.3.png", this.resid.ScopedResourceName(["background3", "image3"])));
	}

	public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		await super.ResourcesLoaded(loadingStage, resourceManager);
		
		if (loadingStage != LoadingStage.Games) return;

		await this.CreateCanvasInfoStats();
		await this.winContainerLoaded(resourceManager);
	}

	protected CreateCanvasInfoStats() {
		let containerRemainingSpinsCanvas = CreateElement("div", {
			classes: ["remainingSpinsContainer"],
			parentToAppend: this.view,
			style: {
				width: Scale.Wpx(1920),
				height: Scale.Hpx(100),
				//color: "white",
				//margin : "auto",                       
				display: "flex",
				margin: "auto",
				position: "absolute",
				alignItems: "center",
				top: Scale.Ypx(1100),
			}
		});

		this.remainingSpinsCanvas = this.CreateCanvas(new Size(Scale.W(1920), Scale.H(150)), this.infoHeightRemainingSpinsCanvas, "white", "white", "white");
		this.remainingSpinsCanvas.view.style.left = "0px";
		this.remainingSpinsCanvas.view.style.top = "0px";

		containerRemainingSpinsCanvas.appendChild(this.remainingSpinsCanvas.View());
		//this.DrawTextCanvas("SPINS REMAINING", this.remainingSpinsCanvas.context, this.remainingSpinsCanvas);
		this.gameState = ExtededSpinAndHoldBonusGameState.SpinsRemaining;
		this.translator.SetOnLanguageChangedCallback(() => {
			this.ChangeStateCanvas(this.gameState, this.session.RunsRemaining);
		});
		containerRemainingSpinsCanvas = null;
	}
	protected gameState: ExtededSpinAndHoldBonusGameState;
	// protected PrepareReelsContainer(resourceManager: ResourceManager): void {
	// 	this.reelsContainer = CreateElement("div", {
	// 		classes: ["reelsContainer"], parentToAppend: this.view,
	// 		style: {
	// 			//width: Scale.Wpx(1920),
	// 			//height: Scale.Wpx(1956),
	// 			position: "absolute",
	// 			//bottom : "0px",
	// 		}
	// 	})


	// }

	protected override async FeaturesPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		await super.FeaturesPrepare(resourceManager);

		// {
		// 	await this.unlockFeature.PrepareResources(resourceManager);
		// }
	}

	protected override async FeaturesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		await super.FeaturesLoaded(resourceManager);

		// {
		// 	await this.unlockFeature.ResourcesLoaded(resourceManager);
		// 	this.view.appendChild(this.unlockFeature.View());
		// }
	}

	protected override ConstructReelParams(constructReelsParams: ConstructReelsParams) {
		let xratio = 1;
		let yratio = 1;

		// depends on the size
		const windowRectangle = new Rect(Scale.X(115.0) * xratio, Scale.Y(1215) * yratio, Scale.W(1690.0) * xratio, Scale.H(1870.0) * yratio);


		this.spinnableReels2 = new S2_SpinnableReelsBigCanvas2(
			this.resid,
			{
				reelConfig: constructReelsParams.ReelSet,
				playWindow: constructReelsParams.PlayWindow,
			},
			{
				windowRect: windowRectangle,
				leftBorderWidth: this.params.spinnableReelsParams.leftBorderWidth,
				rightBorderWidth: this.params.spinnableReelsParams.rightBorderWidth,
				topBorderWidth: this.params.spinnableReelsParams.topBorderWidth,
				bottomBorderWidth: this.params.spinnableReelsParams.bottomBorderWidth,
				//pixiSpritesByName : this.params.pixiSpritesByName
			},
			this.systemContext,
			true
		);
	}

	protected override ConstructReels2(constructReelsParams: ConstructReelsParams)
	{
		super.ConstructReels2(constructReelsParams);

		// let params: IUnlockFeatureParams =
		// {
		// 	resid: this.resid,
		// 	translator: this.translator,
		// 	systemContext: this.systemContext,
		// 	gameBonusResourcesBasePath: this.params.gameBonusResourcesBasePath,
		// 	commonBonusResourcesBasePath: this.params.commonBonusResourcesBasePath,
		// 	//windowRectangle: this.spinnableReels2.GetWindowRect(),
			
		// 	audio: this.audio,
		// 	gameName : this.gameName,
		// 	aspectFixY: ParseMonitors().AspectFixY,
		// }

		// this.unlockFeature = new UnlockFeature(params, FilterFeatures(this.config.MultiFeatureConfiguration, (f): f is UnlockRowsConfig => f.FeatureType == "UnlockRows"));
		// params = null;
	}
	protected oldDisplayed: number;
	protected override OnFeaturesBegin(): void {
		super.OnFeaturesBegin();
		let ScatterRandomAward = this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult
		if (ScatterRandomAward.ScattersAddedThisSpin > 0) {
			this.gameState = ExtededSpinAndHoldBonusGameState.SpinsRemaining;
			this.ChangeStateCanvas(this.gameState, this.session.RunsRemaining);
			ScatterRandomAward = null;
		}
		let unlockRowsSimpleLastAction = this.simpleLastBonusAction.SpinWithFeatures.FeatureResults["UnlockRows"] as UnlockRowsResult
		//this.unlockFeature.UpdateSraUnlock(unlockRowsSimpleLastAction);

		if (unlockRowsSimpleLastAction.Rows.length > 0 && this.simpleLastBonusAction.SpinsRemaining == 3) {
			this.audio.Track(this.resid.ScopedResourceName("bounceSound")).Play();
			unlockRowsSimpleLastAction = null;
		}
	}

	public override Start(): void {
		super.Start();
		//this.animWinCount.restart();
		//this.animWinCount.pause();		
		this.winContainer.style.display = "none";
		this.WinValue = 0;
		this.DrawTextCanvas("?", this.winCountCanvas, this.infoHeightWinCount);
		// this.unlockFeature.RestartAnim();
		// this.unlockFeature.StartAnim();
		this.gameState = ExtededSpinAndHoldBonusGameState.SpinsRemaining;
		this.ChangeStateCanvas(ExtededSpinAndHoldBonusGameState.SpinsRemaining, this.session.RunsRemaining);
		this.indexsimpleLastSpinAction = 0;
	}

	public override Prepare(bonusStartConfig: IBonusStartConfig) {
		super.Prepare(bonusStartConfig);

		let simplestartConfig = bonusStartConfig.actions as SpinAndHoldStartAction[];
		let startConfigExtended = simplestartConfig.find(b => b.Phase == "Start");
		if (startConfigExtended) {
			let scatterStartConfig = startConfigExtended.SpinWithFeatures.FeatureResults["UnlockRows"] as unknown as UnlockRowsResult
			//this.unlockFeature.Start(scatterStartConfig);
			simplestartConfig = null;
			scatterStartConfig = null;
		}
	}

	protected override DesinationComet(): Point {
		let destination: Point = TranslateScreen1To1(new Rect(0,Scale.Y(50), Scale.W(1920), Scale.H(1080))).Center();
		return destination
	}
	protected winContainer: HTMLElement;
	//protected jackpotHideAnimContainer: HTMLElement;
	protected frameSprite: CanvasSprite;

	protected async winContainerLoaded(resourceManager: IReadOnlyResourceManager) {

		// this.jackpotHideAnimContainer = CreateElement("div", {
		// 	classes: [this.resid.Scope(), "WinContainer"],
		// 	parentToAppend: this.view,
		// 	style: {
		// 		position: "relative",
		// 		top: Scale.Ypx(-1080),
		// 		//background : "black",
		// 		//left: Scale.Xpx(1920) ,
		// 		width: Scale.Wpx(1920),
		// 		height: Scale.Hpx(1080),
		// 		display: "none",
		// 		//backgroundColor:"rgba(0,0,0,0.6)",
		// 		//flexDirection:"column",
		// 		zIndex: "" + ZIndex.BackgroundBonus,
		// 		//overflow:"hidden",
		// 		backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background3", "image3"])).CssBackground(),
		// 	}
		// });

		this.winContainer = CreateElement("div", {
			classes: [this.resid.Scope(), "WinContainer"],
			parentToAppend: this.view,
			style: {
				position: "absolute",
				top: Scale.Ypx(422),
				//background : "black",
				//left: Scale.Xpx(1920) ,
				width: Scale.Wpx(1920),
				height: Scale.Hpx(423),
				display: "flex",
				//flexDirection:"column",
				zIndex: "" + ZIndex.BonusWin,
				//overflow:"hidden"
			}
		});

		let frameSpriteContainer = CreateElement("div", {
			classes: ["WinContainer-", "frameSpriteContainer"],
			parentToAppend: this.winContainer,
			style: {
				//backgroundColor:"rgba(0,0,0,0.7)",
				width: Scale.Wpx(1590),
				height: Scale.Hpx(347),
				//position:"absolute",
				margin: "auto",
				display: "flex",
				//top: Scale.Ypx(40),
				//left: Scale.Xpx(76),
			}
		});

		this.bonusWinSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("bonusTitleExtendedSpinAndHold")).sprite, canvasSize: new Size(Scale.W(1720), Scale.H(300))});
		this.bonusWinSprite.Scale(1.1);
		this.bonusWinSprite.View().style.position = "absolute";
		this.bonusWinSprite.View().style.top = Scale.Ypx(-298);
		this.bonusWinSprite.View().style.left = Scale.Xpx(108);
		//this.bonusWinSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("WinCount")));
		this.winContainer.appendChild(this.bonusWinSprite.View());
		//	this.bonusWinSprite.Start(true);

		this.frameSprite = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("frameSpriteExtendedSpinAndHold")).sprite, canvasSize: new Size(Scale.W(1720), Scale.H(500))});
		this.frameSprite.View().style.position = "absolute";
		this.frameSprite.View().style.top = Scale.Ypx(-56);
		this.frameSprite.View().style.left = Scale.Xpx(108);
		this.frameSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("WinCount")));
		frameSpriteContainer.appendChild(this.frameSprite.View());
		//this.frameSprite.Start(true);


		this.winCountCanvas = this.CreateCanvas(new Size(Scale.W(1580), Scale.H(310)), Scale.fh(200));
		this.winCountCanvas.View().style.position = "relative";
		this.winCountCanvas.View().style.margin = "auto";
		this.winCountCanvas.View().style.left = Scale.Xpx(-152);
		this.winContainer.appendChild(this.winCountCanvas.View());
		this.DrawTextCanvas("?", this.winCountCanvas, this.infoHeightWinCount);

		//this.CreateWinContShowAnim();
	}

	public override Update(): void {
		super.Update();
		this.frameSprite.Update();
		this.bonusWinSprite.Update();
		//this.unlockFeature.Update();

		//Redraw Canvas Info Stats
		if (this.remainingSpinsCanvas.WasContextLost) {
			this.ChangeStateCanvas(this.gameState, this.session.RunsRemaining);
		}
		if (this.winCountCanvas.WasContextLost) {
			this.DrawTextCanvas(service.moneyFormatter.FormatCurrency(this.WinValue), this.winCountCanvas, this.infoHeightWinCount);
		}
	}

	protected override OnSpinIdleBegin(): void {
		super.OnSpinIdleBegin();


		if (this.session.RunsRemaining < 1) {
			this.gameState = ExtededSpinAndHoldBonusGameState.WinCount;
			this.ChangeStateCanvas(this.gameState);			
		}
	}

	protected override OnCometCollectBegin(): void {
		super.OnCometCollectBegin();
		this.WinCountShow();
	 }

	protected WinCountShow() {
		TweenLite.fromTo(this.winContainer, 4, {
			x: Scale.Xpx(1920), display: "none", alpha: 0, delay: 2
		}, {
			x: Scale.X(0), display: "flex", alpha: 1, ease: Elastic.easeOut.config(0.50, 0.4)
		});

		if (globalThis.jackpotDisplayGlobal != null) {
			TweenLite.to(globalThis.jackpotDisplayGlobal.View(), 2.5, {
				alpha: 0
			});
		}
	}

	protected override OnSpinBegin(): void {
		super.OnSpinBegin();
		if (this.session.RunsRemaining >= 1) {
			this.gameState = ExtededSpinAndHoldBonusGameState.SpinsRemaining;
			this.ChangeStateCanvas(this.gameState, this.session.RunsRemaining);
		}
		else {
			this.gameState = ExtededSpinAndHoldBonusGameState.LastSpin;
			this.ChangeStateCanvas(this.gameState);
		}
	}



	protected CreateCanvas(size: Size, fontHeight: number, colorTopBottom: string = "#F2E416", colorMiddle: string = "#F2BE22", colorCenter: string = "#C2760E"): MyCanvas {
		let canvas = new MyCanvas(size, {
			style: {
				display: "flex",
				zIndex: "" + ZIndex.BonusWin

			}
		});
		return canvas;
	}

	public DrawTextCanvas(text: string, Canvas: MyCanvas, fontHeight: number) {
		Canvas.context.clearRect(0, 0, Canvas.size.Width, Canvas.size.Height);
		Canvas.context.font = fontHeight + "px NotoSansDisplay-Bold" /*+ this.font*/;

		let color: string = "#F2E416";
		let color2: string = "#F2BE22";
		let color3: string = " #C2760E";
		let color4: string = "#F2BE22";
		let color5: string = "#F2E416";

		let gradient = Canvas.context.createLinearGradient(Canvas.rect.width / 2,
			Canvas.rect.height / 2 - fontHeight / 2,
			Canvas.rect.width / 2,
			Canvas.rect.height / 2 + fontHeight / 2
		);

		gradient.addColorStop(0, color);
		gradient.addColorStop(0.25, color2);
		gradient.addColorStop(0.50, color3);
		gradient.addColorStop(0.75, color4);
		gradient.addColorStop(1, color5);

		Canvas.context.fillStyle = gradient;
		Canvas.context.textBaseline = "middle";
		Canvas.context.textAlign = "center";
		Canvas.context.lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
		Canvas.context.miterLimit = 2;
		Canvas.context.shadowBlur = 20;
		Canvas.context.shadowColor = "black";
		Canvas.context.shadowOffsetX = 5;
		Canvas.context.shadowOffsetY = 5;
		//Canvas.context.save();

		Canvas.context.strokeStyle = "black";
		Canvas.context.lineWidth = Scale.fh(10);
		Canvas.context.strokeText(text, (Canvas.size.Width / 2), (Canvas.size.Height / 2));
		Canvas.context.fillText(text, (Canvas.size.Width / 2), (Canvas.size.Height / 2));
		Canvas.RestoreContext();
		gradient = null;
		color = null;
		color2 = null;
		color3 = null;
		color4 = null;
		color5 = null;
	}
	protected WinValue: number = 0;
	protected override SendWinInfo(win: number) {
		super.SendWinInfo(win);
		if (this.winValues == 0) {
			this.DrawTextCanvas("?", this.winCountCanvas, this.infoHeightWinCount);
		}
		else {
			this.WinValue += win;
			this.bonusWinSprite.Start(false);
			this.frameSprite.Start(false);
			this.DrawTextCanvas(service.moneyFormatter.FormatCurrency(this.WinValue), this.winCountCanvas, this.infoHeightWinCount);
		}


	}

	// protected CreateWinContShowAnim() {





	// }

	//FIx tittle transition Position 
	// public LoadTransition(resourceManager: ResourceManager) {
	// 	super.LoadTransition(resourceManager);
	// 	this.transitionView.View().style.position = "relative";
	// 	this.transitionView.View().style.top = Scale.Ypx(1080);
	// }

	protected override OnIntroMessageBegin(): void {
		this.HideAllContainers();
		this.ShowContainer(SpinAndHoldContainer.IntroMessage);
		this.ShowContainer(SpinAndHoldContainer.Reels);
		this.holdingFeature.View().style.display = "block";


		this.PanelRequired(true);
		this.robotPlay.BonusConfirm("IntroMessage");
		//this.unlockFeature.StartAnim();
	}


	public ChangeStateCanvas(state: ExtededSpinAndHoldBonusGameState, runRemaining: number = 0) {


		switch (state) {
			case ExtededSpinAndHoldBonusGameState.SpinsRemaining:
				this.DrawTextCanvas(this.translator.t.extendendDiamondSpinRemaining(runRemaining), this.remainingSpinsCanvas, this.infoHeightRemainingSpinsCanvas);
				break;
			case ExtededSpinAndHoldBonusGameState.LastSpin:
				this.DrawTextCanvas(this.translator.t.extendendLasSpinMessage, this.remainingSpinsCanvas, this.infoHeightRemainingSpinsCanvas);
				break;
			case ExtededSpinAndHoldBonusGameState.WinCount:
				this.DrawTextCanvas(this.translator.t.goodluck, this.remainingSpinsCanvas, this.infoHeightRemainingSpinsCanvas);
				break;
		}
	}

	public override async PrepareTransition(resourceManager: IWriteOnlyResourceManager) {

		let pathTrack: string;
		let pathSprite: string;
		let pathVideo: string;
		if (Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay) {

			let pathTrack = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + this.jackpotName + "/tracks/" + this.jackpotName + Settings.audioFormat;
			let pathSprite = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + this.jackpotName + "/" + this.jackpotName + "_Transition";
			let pathVideo = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + this.jackpotName + "/Background_" + this.ScreenNumberConfiguration + "S";
			//Overwrite this video path because for this jackpots need different 
			if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotOrtiz || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStep || Settings.JackpotDisplayType == JackpotDisplayType.DragonJackpot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotRappidFrames) {
				pathVideo = Settings.ResourcesFolder + "multigame/slot/" + this.gameName + "/resources/video/presentation_" + this.ScreenNumberConfiguration + "s";
				//pathTrack  = this.params.commonpath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + this.jackpotName + "/tracks/DiamondPot" + Settings.audioFormat;
			}

			resourceManager.AddGlobal(new SpriteResource(pathSprite, ResourceIdentifier.Global.Add("TitleTransition").Add(this.bonusName), true, LogGroup.Global.Add("TitleTransition").Add(this.bonusName), true))
			this.audio.AddTrack(new Track(pathTrack, this.resid.ScopedResourceName("VoiceJackpotType")));

			if (Settings.PresentationType == Presentation.VideoGameSprite) {
				resourceManager.AddGlobal(new VideoResource2({
					resid: ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
					logGroup: LogGroup.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
					src: pathVideo,
					unloadOnHide: true
				}));
			}
			else if (Settings.PresentationType == Presentation.VideoCommonNoSprite) {
				pathVideo = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + this.jackpotName + "/BackgroundVideoSprite_" + this.ScreenNumberConfiguration + "S";
				resourceManager.AddGlobal(new VideoResource2({
					resid: ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
					logGroup: LogGroup.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
					src: pathVideo,
					unloadOnHide: true
				}));
			}
			else if (Settings.PresentationType == Presentation.Image) {
				let pathImgTransition = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + this.jackpotName + "/BackgroundTransition_" + this.ScreenNumberConfiguration + "S.png";
				if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPot || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotOrtiz || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStep) {
					pathImgTransition = `${this.params.gamepath}resources/BackgroundTransition_${this.ScreenNumberConfiguration}S.png`;
				}
				resourceManager.AddGlobal(new ImageResource(pathImgTransition,
					ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-BackgroundTransition-" + this.ScreenNumberConfiguration).Scope()));
				//debugger
			}
			else if (Settings.PresentationType == Presentation.VideoCommonClassic) {
				pathVideo = this.params.commonBonusResourcesBasePath + "resources/VideosBackgroundResources-Transition/" + this.jackpotName + "/BackgroundCommonVideo_" + this.ScreenNumberConfiguration + "S";
				resourceManager.AddGlobal(new VideoResource2({
					resid: ResourceIdentifier.Global.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
					logGroup: LogGroup.Global.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
					src: pathVideo,
					unloadOnHide: true
				}));
			}
			else if (Settings.PresentationType == Presentation.VideoParticleTransitionMatterJS) {
				resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle-Transition`, this.resid.Add("Partitle-Transition").Shared(), true, this.logGroup.Add("Partitle-Transition"), true));
				// resourceManager.AddGlobal(new JSONResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/partitleTransitionBoundingBox.json`,
				// ResourceIdentifier.Global.Add(this.gameName + "-" +this.bonusName + "-partitleTransitionBoundingBox").Shared().CSSScope(),true));
			}
			else if (Settings.PresentationType == Presentation.VideoParticleTransitionFadeInFadeOut) {
				resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle-Transition`, this.resid.Add("Partitle-Transition").Shared(), true, this.logGroup.Add("Partitle-Transition"), true));
				// resourceManager.AddGlobal(new JSONResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/partitleTransitionBoundingBox.json`,
				// ResourceIdentifier.Global.Add(this.gameName + "-" +this.bonusName + "-partitleTransitionBoundingBox").Shared().CSSScope(),true));
			}
			pathTrack = null;
			pathSprite = null;
			pathVideo = null;
		}
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/BounceSound" + Settings.audioFormat, this.resid.ScopedResourceName("bounceSound")));

	}

	// //LOAD FOR TRANSITION 
	public override async TransitionLoaded(resourceManager: IReadOnlyResourceManager) {
		let transitionResources: ITransitionParams = null;
		if (Settings.PresentationType == Presentation.VideoGameSprite) {
			transitionResources = {
				spriteResource: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add(this.bonusName)),
				videoResource: resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration)),
				soundResource: this.audio.Track(this.resid.ScopedResourceName("VoiceJackpotType")),
				audio: this.audio,
				//basePath: this.params.commonpath,
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid,
				imgResource: null,
				nameResource: this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration,
				fadeOut: this.EnableFadeOutVideo(),
				particlesSprite : null,
				//boundingBox : null
				transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
			};
		}
		else if (Settings.PresentationType == Presentation.Image) {
			transitionResources = {
				spriteResource: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add(this.bonusName)),
				videoResource: null,
				soundResource: this.audio.Track(this.resid.ScopedResourceName("VoiceJackpotType")),
				audio: this.audio,
				//basePath: this.params.commonpath,
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid,
				imgResource: resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-BackgroundTransition-" + this.ScreenNumberConfiguration)),
				nameResource: null,
				fadeOut: this.EnableFadeOutVideo(),
				particlesSprite : null,
				//boundingBox : null
				transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
			};

		}
		else if (Settings.PresentationType == Presentation.VideoCommonNoSprite) {
			transitionResources = {
				spriteResource: null,
				videoResource: resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add(this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration)),
				soundResource: this.audio.Track(this.resid.ScopedResourceName("VoiceJackpotType")),
				audio: this.audio,
				//basePath: this.params.commonpath,
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid,
				imgResource: null,
				nameResource: this.gameName + "-" + this.bonusName + "-Transition-" + this.ScreenNumberConfiguration,
				fadeOut: this.EnableFadeOutVideo(),
				particlesSprite : null,
				//boundingBox : null
				transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
			};
		}
		else if (Settings.PresentationType == Presentation.VideoCommonClassic) {
			transitionResources = {
				spriteResource: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add(this.bonusName)),
				videoResource: resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add(this.bonusName+"-Transition-"+this.ScreenNumberConfiguration)),
				soundResource: this.audio.Track(this.resid.ScopedResourceName("VoiceJackpotType")),
				audio: this.audio,
				//basePath: this.params.commonPath,
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid.Add(this.bonusName+"-Transition-"+this.ScreenNumberConfiguration),
				imgResource: null,
				nameResource : this.bonusName+"-Transition-"+this.ScreenNumberConfiguration,
				fadeOut : true,
				particlesSprite : null,
				//boundingBox : null
				transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
			};
		}
		else if (Settings.PresentationType == Presentation.VideoParticleTransitionMatterJS) {
			//let jsonBoundingBox = (resourceManager.Get<JSONResource>(this.resid.Add(`Symbol-PartitleTransitionBoundingBox`).Shared().CSSScope()).json) as IMyBoundingBox;
			transitionResources = {
				spriteResource: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add(this.bonusName)),
				videoResource: null,
				soundResource: this.audio.Track(this.resid.ScopedResourceName("VoiceJackpotType")),
				audio: this.audio,
				//basePath: this.params.commonPath,
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
				imgResource: null,
				nameResource: this.bonusName + "-Transition-" + this.ScreenNumberConfiguration,
				fadeOut: true,
				particlesSprite : resourceManager.Get<PixiSpriteResource>(this.resid.Add(`Partitle-Transition`).Shared()).sprite,
				boundingBox : null,
				transitionPIXITypeStyle : this.params.gameConfig.transitionPIXITypeStyle,
			};
		}
		else if (Settings.PresentationType == Presentation.VideoParticleTransitionFadeInFadeOut) {
			//let jsonBoundingBox = (resourceManager.Get<JSONResource>(this.resid.Add(`Symbol-PartitleTransitionBoundingBox`).Shared().CSSScope()).json) as IMyBoundingBox;
			transitionResources = {
				spriteResource: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add(this.bonusName)),
				videoResource: null,
				soundResource: this.audio.Track(this.resid.ScopedResourceName("VoiceJackpotType")),
				audio: this.audio,
				//basePath: this.params.commonPath,
				logGroup: this.logGroup,
				systemContext: this.systemContext,
				gameName: this.gameName,
				resid: this.resid.Add(this.bonusName + "-Transition-" + this.ScreenNumberConfiguration),
				imgResource: null,
				nameResource: this.bonusName + "-Transition-" + this.ScreenNumberConfiguration,
				fadeOut: true,
				particlesSprite : resourceManager.Get<PixiSpriteResource>(this.resid.Add(`Partitle-Transition`).Shared()).sprite,
				boundingBox : null,
				transitionPIXITypeStyle : TransitionPIXITypeStyle.gameStyle,
			};
		}
		else {
			throw `${Settings.PresentationType} its not implemented change your setting PresentationType`
		}

		await this.systemContext.SharedTransitionContext().AddTransition(transitionResources);


		// this.transitionView = this.transitionViewFactory.Create(transitionResources);
		// transitionResources = null;
		// //this.transitionView.PrepareResources(resourceManager);

		// await this.transitionView.ResourcesLoaded(resourceManager);
		// this.view.appendChild(this.transitionView.View());


		// if (Settings.fillingPotFeature == FillingPotFeature.Disable) {
		// 	this.transitionView.View().style.position = "absolute";
		// 	this.transitionView.View().style.bottom = Scale.Ypx(0);
		// }

		
		// this.transitionView.onTransitionStart = () => {
		// 	this.OnTransitionStarted();
		// }

		// this.transitionView.onTransitionEnd = () => {
		// 	this.OnTransitionEnded();
		// }



		this.transitionView = await this.systemContext.SharedTransitionContext().AddTransition(transitionResources);		
		//this.transitionView.ResourcesLoaded(resourceManager);		
		this.transitionView.onTransitionEnd = () => {
			this.OnTransitionEnded()
		}
		this.transitionView.onTransitionStart = () => {
			this.OnTransitionStarted()
		}

	}

	// protected override OnTransitionEnded(): void {
	// 	this.started = false;
	// 	if (this.stateMachine.State() == SpinAndHoldState.FinalMessage) {
	// 		this.stateMachine.ChangeState(SpinAndHoldState.Idle);
	// 	} else {
	// 		this.stateMachine.ChangeState(SpinAndHoldState.IntroMessage);
	// 	}
	// }

	protected override EnableFadeOutVideo(): boolean {
		return false;
	}

	protected override OnFinalMessageEnd(): void {
		super.OnFinalMessageEnd()
		if (globalThis.jackpotDisplayGlobal != null) {
			globalThis.jackpotDisplayGlobal.View().style.opacity = "1";
		}
	}


	public override HistoryView(actionIndex: number, gameState: SimpleSlotGameState): HTMLElement {
		//let gameState: SimpleSlotGameState = JSON.parse(entry2.HistoryGameState.GameState);
		const spin: SpinAndHoldSpinAction = gameState.Actions[actionIndex] as SpinAndHoldSpinAction;
		const start: SpinAndHoldStartAction = gameState.Actions.slice(0, actionIndex).reverse().find(a => a.Phase == SimpleBonusPhase.Start) as SpinAndHoldStartAction;
		
		const playWindow: PlayWindow = start.PlayWindow;
		assertNotNullish(playWindow, `No play window set`);
		
		const reelSet = this.config.MultiReelSets[start.ReelSetId];
		assertNotNullish(reelSet, `No reels for reel set ${start.ReelSetId}`);


		let bonusView: HTMLElement = CreateElement("div", {
			classes: ["bonusView", "SpinAndHoldHistory"],
			style:
			{
				width: "100%",
				height: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexDirection: "row",
			}
		});

		let reelView: HTMLElement = null;
		let gameView: HTMLElement = CreateElement("div", {
			classes: ["gameBackground"], parentToAppend: bonusView,
			style:
			{
				width: Scale.Wpx(900),
				height: Scale.Hpx(700),
				backgroundRepeat: "no-repeat",
				backgroundSize: "cover",
				backgroundPosition: "center",
				display: "flex",
				flexDirection: "row",
				justifyContent: "center",
				alignItems: "center",
				backgroundImage: this.gameBackground,
			}
		});

		if (spin.Phase == "Start" || spin.Phase == "Spin") {
			console.log(`Scatter positions`, (spin.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult).ScattersPosition);
			// reel view
			reelView = CreateElement("div", {
				classes: ["reelView"], parentToAppend: gameView,
				style:
				{
					width: Scale.Wpx(900),
					height: Scale.Hpx(700),
				}
			});


			let reelTable: HTMLElement = CreateElement("table", { classes: ["reelTable"], parentToAppend: reelView, style: { width: "100%", height: "100%", borderCollapse: "collapse" } });
			//config rows
			// let configRows = this.config.FeatureConfiguration.find(f => f.FeatureType == "UnlockRows") as UnlockRowsConfig;

			let unlockRows = spin.SpinWithFeatures.FeatureResults["UnlockRows"] as UnlockRowsResult;

			for (let i = 0; i < playWindow.Height; i++) {
				let tr: HTMLElement = CreateElement("tr", { classes: ["tr"], parentToAppend: reelTable });
				
				if (unlockRows != null &&
					i < unlockRows.Rows.length &&
					unlockRows.CountTotal < unlockRows.Rows[i].Unlock)
				{
					// locked
					SetStyles(tr, {
						border: "5px solid red",
						backgroundColor: "rgba(255, 0, 0, 0.2)"
					});
				}

				for (let j = 0; j < playWindow.Width; j++) {

					let coulmnWidth: number = 100 / playWindow.Width;
					let rowHeigt: number = 100 / playWindow.Height;
					let reel = reelSet.find((r) => r.Row == i && r.Col == j);
					if (reel == null) {

					}
					else {
						let td: HTMLTableDataCellElement = CreateElement("td", {
							classes: ["td"], parentToAppend: tr,
							style: {
								//border:"5px solid blue",
								fontSize: Scale.fhpx(80),
								width: "" + (coulmnWidth * reel.ColSpan) + "%",
								height: "" + (rowHeigt * reel.RowSpan) + "%",
								textAlign: "center",
							}
						});
						td.colSpan = reel.ColSpan;
						td.rowSpan = reel.RowSpan;

						// TODO what if the action is start action?
						// should just skip it...




						let scatterPosition: AwardOptionPosition = (spin.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult).ScattersPosition.find(s => j == s.Col && i == s.Row);
						//let scatterPosition: AwardOptionPosition =(spin.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult).ScattersPosition.find(s => j == s.Col && i == s.Row);

						console.log(`Checking col ${j} row ${i}: `, scatterPosition);

						if (scatterPosition) {
							//td.innerHTML = ""+scatterPosition.AwardOption.BetMultiplier;
							let ValueCanvas = new MyCanvas(new Size(Scale.W((coulmnWidth * reel.ColSpan) * 6), Scale.H((rowHeigt * reel.RowSpan) * 4)));
							ValueCanvas.context.canvas.style.zIndex = "" + ZIndex.BonusWin;
							//add gradient
							//ValueCanvas.context.font = "bold " + 50 + "px " + "NotoSansDisplay-BoldItalic";
							//ValueCanvas.context.fillStyle = "White";
							ValueCanvas.context.textBaseline = "middle";
							ValueCanvas.context.textAlign = "center";
							ValueCanvas.context.lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
							ValueCanvas.context.miterLimit = 2;
							ValueCanvas.context.shadowBlur = 5;
							ValueCanvas.context.shadowColor = "black";
							//ValueCanvas.context.shadowOffsetX = 8;
							//ValueCanvas.context.shadowOffsetY = 8;
							td.appendChild(ValueCanvas.context.canvas);

							throw new Error("Scatter random award has many required symbols. What symbol to draw?");
							// let symbol = this.params.symbolSpriteAnimsByName.get(this.scatterRandomAwardFeature.RequiredSymbol().ID);
							// symbol.Draw(ValueCanvas);

							this.scatterRandomAwardFeature?.GetHistoryValueCanvas({
								bet: gameState.Bet.Bet,
								scatterPosition: scatterPosition,
								parentElement: ValueCanvas
							});
						}
						else {
							let symbol = this.params.symbolSpriteAnimsByName.get(spin.SpinWithFeatures.ExpectedSymbols[j][i]);
							let ValueCanvas = new MyCanvas(new Size(Scale.W((coulmnWidth * reel.ColSpan) * 6), Scale.H((rowHeigt * reel.RowSpan) * 4)));
							ValueCanvas.context.canvas.style.zIndex = "" + ZIndex.BonusWin;
							//add gradient
							//ValueCanvas.context.font = "bold " + 50 + "px " + "NotoSansDisplay-BoldItalic";
							//ValueCanvas.context.fillStyle = "White";
							ValueCanvas.context.filter = "brightness(50%)";
							//ValueCanvas.context.shadowOffsetX = 8;
							//ValueCanvas.context.shadowOffsetY = 8;
							td.appendChild(ValueCanvas.context.canvas);
							symbol.Draw(ValueCanvas);
						}
					}
				}
			}
		}
		else if (spin.Phase == "End") {
			let endAction = gameState.Actions[actionIndex] as ExtendedSpinAndHoldEndAction;
			gameView.style.flexDirection = "column";
			let titleBonusWin: HTMLElement = CreateElement("div", {
				classes: ["titleBonusWin"], parentToAppend: gameView,
				style:
				{
					width: "100%",
					height: Scale.Hpx(300),
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",
					fontSize: Scale.fhpx(100),
					color: "white",
					textShadow: `${Scale.XY(10)}px ${Scale.XY(10)}px ${Scale.XY(10)}px black, 0px 0px ${Scale.XY(20)}px black, 0px 0px ${Scale.XY(30)}px black`,

				}
			});
			titleBonusWin.innerText = " Bonus Win";

			let winView: HTMLElement = CreateElement("div", {
				classes: ["winView"], parentToAppend: gameView,
				style:
				{
					width: "80%",
					height: Scale.Hpx(180),
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					backgroundPosition: "center",
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",
					backgroundColor: "rgba(0,0,0,0.5)",
					fontSize: Scale.fhpx(100),
					color: "white",
					textShadow: `0px 0px ${Scale.XY(10)}px black, 0px 0px ${Scale.XY(20)}px black, 0px 0px ${Scale.XY(30)}px black`,
					borderWidth: Scale.XYpx(5),
					borderStyle: "solid",
					filter: `blur(${Scale.XYpx(2)})`,
					backgroundImage: "linear-gradient(rgb(0, 0, 0), rgb(22, 22, 206),rgb(0, 0, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
				}
			});
			winView.innerText = service.moneyFormatter.FormatCurrency(endAction.WinSinceGameStart.TotalWin.InCents)
		}
		return bonusView;
	}



	// public override HistoryStats2(actionIndex: number, entry2: HistoryGame): ActionStats {
	// 	// TODO what if the action is start action?
	// 	// should just skip it...

	// 	let gameState: SimpleSlotGameState = JSON.parse(entry2.HistoryGameState.GameState);
	// 	let action: SpinAndHoldSpinAction = gameState.Actions[actionIndex] as unknown as SpinAndHoldSpinAction;
	// 	let historyStats: HistoryStats[] = [];
	// 	if (action.Phase == "Start" || action.Phase == "Spin") {
	// 		let baseSpinBet: number = entry2.Bet;

	// 		return {
	// 			Bonus: action.Bonus,
	// 			Action: action.Action,
	// 			Stats: [
	// 				{ key: "Runs played", value: service.moneyFormatter.FormatQuantity(action.SpinsPlayed) },
	// 				{ key: "Runs remaining", value: service.moneyFormatter.FormatQuantity(action.SpinsRemaining) },
	// 			]
	// 		}
	// 	}
	// 	else
	// 	{
	// 		let endAction = gameState.Actions[actionIndex] as ExtendedSpinAndHoldEndAction;
	// 		return {
	// 			Bonus: action.Bonus,
	// 			Action: action.Action,
	// 			Stats: [
	// 				{ key: "Bonus Win:", value: service.moneyFormatter.FormatCurrency(endAction.WinSinceBonusStart.TotalWin.InCents) },
	// 				{ key: "Total Win:", value: service.moneyFormatter.FormatCurrency(endAction.WinSinceGameStart.TotalWin.InCents) },
	// 			]
	// 		}

	// 	}

	// }
	// protected override PlayCometSound(){
	// 	this.audio.Play(this.resid.ScopedResourceName("cometExtended"));
	// }
	protected override RequestStopsCommetShowWin() {		
		this.commetView.StopsCommets()
		//this.audio.Stop(this.resid.ScopedResourceName("cometExtended"));		
		this.commetView.StopCometSound();
		this.timeoutNextCommetCash.Stop();	
	}

	// protected override async CometAudioPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void> {
	// 	this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "resources/tracks/cometShort" + Settings.audioFormat, this.resid.ScopedResourceName("cometExtended")));
	// }

	// protected override async CometsPrepare(resourceManager: IWriteOnlyResourceManager): Promise<void>
	// {				
	// 	this.commetView = this.commetFactory.CreateComect();
	// 	this.commetView.PrepareResources(resourceManager);
	// }

	// protected override async SpriteCometsLoaded(resourceManager: IReadOnlyResourceManager){
	// 	this.commetView.ResourcesLoaded(resourceManager);
	// 	this.commetView.OnCompleteCallback = this.OnCometEnd.bind(this);
	// }
}
